import * as React from 'react'

import { AccountTheme } from 'src/types/theme'

const palette: AccountTheme['palette'] = {
  primary: '#086ad8',
  secondary: '#868C97',
  success: '#00B779',
  danger: '#EC4B5F',
  warning: '#DEBA56',
  info: '#F3F3F4',
  light: '#fff',
  dark: '#354052',
}

const logo: AccountTheme['logo'] = {
  dark: {
    key: '',
    name: 'Dark Logo',
  },
  light: {
    key: '',
    name: 'Light Logo',
  },
}

const login: AccountTheme['login'] = {
  text: '',
  backgroundColor: '',
}

const ThemeContext = React.createContext({
  palette,
  logo,
  login,
})

export default ThemeContext



// WEBPACK FOOTER //
// ./src/utils/theme/index.tsx